/* Package JSON Import will be here */
import axios from "axios";
import { isObject } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { GAExceptionTracking, GAWarningTracking } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

/* Handling the Un handled exceptions */
export const onErrorTrack = async (error) => {
    try {
        const StackTrace = await import('stacktrace-js');
        StackTrace.fromError(error).then(async (stack) => {
            const errorMessage = `Error - ${error.message} / Stack - ${stack.join(", ")}`;

            /* Track the exception in google analytics */
            if (window.isEnableGA)
                GAExceptionTracking(errorMessage, "", "", "", errorMessage);

            /* Tract the exception in DB */
            await axios.post(
                `${window.serviceApiUrl}/ClientApp/LogClientAppException`,
                { ExceptionMessage: errorMessage },
                { headers: { "Content-Type": "application/json" } });

            /* Redirect the user to error page */
            window.location.href = "/";
        });
    }
    catch (apiError) {
        /* Console log the error message */
        console.log(error);

        /* Redirect the user to error page */
        setTimeout(() => {
            window.location.href = "/";
        }, 2000);
    }
};

/* Handling the Un handled rejection */
window.onunhandledrejection = async (event) => {
    try {
        const StackTrace = await import('stacktrace-js');
        StackTrace.fromError(event.reason).then(async (stack) => {
            const errorMessage = `Error - ${isObject(event.reason) ? event.reason.stack : event.reason} / Stack - ${stack.join(", ")}`;

            /* Track the exception in google analytics */
            if (window.isEnableGA)
                GAExceptionTracking(errorMessage, "", "", "", errorMessage);

            /* Tract the exception in DB */
            await axios.post(
                `${window.serviceApiUrl}/ClientApp/LogClientAppException`,
                { ExceptionMessage: errorMessage },
                { headers: { "Content-Type": "application/json" } });

            /* Redirect the user to error page */
            window.location.href = "/";
        });

    }
    catch (apiError) {
        /* Console log the error message */
        console.log(isObject(event.reason) ? event.reason.stack : event.reason);

        /* Redirect the user to error page */
        setTimeout(() => {
            window.location.href = "/";
        }, 2000);
    }
};

/*GA - Track Warning*/
console.warn = (msg) => {
    /* Track the warning in google analytics */
    if (window.isEnableGA)
        GAWarningTracking(msg)
};